module.exports = __webpack_public_path__ + "img/cbam-yzs-en.dd340fa6.png";